export default "__VITE_ASSET__BjhmJ8Qz__"